import React, { useContext } from 'react';
import { AUTHENTICATED_ROUTES } from 'routing';
import { Redirect } from 'react-router-dom';
import Video from './components/Video';
import Benefits from './components/Benefits';
import FAQ from './components/FAQ';
import GradeImprovementBlock from './components/GradeImprovementBlock';
import TopTutorsSubjects from './components/TopTutorsSubjects';
import Banner from './components/Banner';
import Hero from './components/Hero';
import AuthContext from 'context/AuthContext';
import OnlineLessonsBlock from './components/OnlineLessonsBlock';
import HowItWorks from './components/HowItWorks';
import GoogleReview from 'pages/Reviews/GoogleReview';
import css from './Home.module.scss';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Home() {
  const auth = useContext(AuthContext);

  if (auth.user && auth.user.is_tutor) {
    return <Redirect to={AUTHENTICATED_ROUTES.TUTOR_DASHBOARD} />;
  }

  return (
    <div className={css.homeContainer}>
      <Banner />
      <Hero />
      <HowItWorks />
      <TopTutorsSubjects />
      <Benefits />
      <OnlineLessonsBlock />
      <FAQ />
      <GoogleReview />
      <Video />
      <GradeImprovementBlock />
    </div>
  );
}
